import _toConsumableArray from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var $ = Object.defineProperty,
    K = Object.defineProperties;
var j = Object.getOwnPropertyDescriptors;
var M = Object.getOwnPropertySymbols;
var V = Object.prototype.hasOwnProperty,
    F = Object.prototype.propertyIsEnumerable;

var z = function z(a, i, e) {
  return i in a ? $(a, i, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : a[i] = e;
},
    v = function v(a, i) {
  for (var e in i || (i = {})) {
    V.call(i, e) && z(a, e, i[e]);
  }

  if (M) {
    var _iterator = _createForOfIteratorHelper(M(i)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        F.call(i, e) && z(a, e, i[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return a;
},
    T = function T(a, i) {
  return K(a, j(i));
};

function g(a, i) {
  return a.filter(function (e) {
    return e.name === i;
  });
}

function R(a, i, e) {
  var P = e(a),
      h = e(i);
  return P < h ? -1 : P === h ? 0 : 1;
}

function H(a, i) {
  return a.map(function (e, P) {
    return i(e) ? P : void 0;
  }).filter(function (e) {
    return typeof e == "number";
  });
}

var b = new Map();

function w() {
  var a = new Date().getTime().toString(),
      i = b.get(a),
      e = i !== void 0 ? i + 1 : 0;
  return e === 0 && (b = new Map()), b.set(a, e), Number("".concat(a).concat(e.toString().padStart(2, "0"))).toString(16);
}

function I(a) {
  return a.length === 0 ? void 0 : a[a.length - 1];
}

function C(a, i) {
  var e = v({}, a);
  return i.forEach(function (P) {
    delete e[P];
  }), e;
}

function L(a) {
  var i = !1;
  return function () {
    i || (i = !0, a());
  };
}

function _(a, i) {
  var e = new Map();
  return _toConsumableArray(a).reverse().filter(function (P) {
    var h = i(P);
    if (h === null) return !0;
    var E = !!e.get(h);
    return e.set(h, !0), !E;
  }).reverse();
}

function D(a, i) {
  return T(v({
    id: w(),
    eventDate: new Date().getTime()
  }, i), {
    name: a
  });
}

function q(a) {
  if (a.length === 0) throw new Error("events parameter is empty");
  var i = g(a, "Initialized"),
      e = g(a, "ActivityRegistered"),
      P = g(a, "Pushed");
  if (i.length > 1) throw new Error("InitializedEvent can only exist once");
  var h = e.map(function (E) {
    return E.activityName;
  });
  P.forEach(function (E) {
    if (!h.includes(E.activityName)) throw new Error("the corresponding activity does not exist");
  });
}

function B(a, i) {
  var e = _(_toConsumableArray(a).sort(function (t, y) {
    return R(t, y, function (o) {
      return o.id;
    });
  }), function (t) {
    return t.id;
  });

  q(e);
  var P = g(e, "Initialized")[0],
      h = g(a, "ActivityRegistered"),
      E = P.transitionDuration,
      f = [];
  e.forEach(function (t) {
    var y;

    switch (t.name) {
      case "Pushed":
        {
          var o = t.skipEnterActiveState || i - t.eventDate >= E ? "enter-done" : "enter-active";
          f.push({
            id: t.activityId,
            name: t.activityName,
            transitionState: o,
            params: t.activityParams,
            context: t.activityContext,
            steps: [{
              id: t.activityId,
              params: t.activityParams,
              pushedBy: t
            }],
            pushedBy: t,
            metadata: {
              poppedBy: null
            },
            isTop: !1,
            isActive: !1,
            zIndex: -1
          });
          break;
        }

      case "Replaced":
        {
          var _o = I(H(f, function (S) {
            return S.id === t.activityId;
          })),
              c = typeof _o == "number" ? f[_o] : void 0,
              s = c ? c.transitionState : t.skipEnterActiveState || i - t.eventDate >= E ? "enter-done" : "enter-active",
              l = {
            id: t.activityId,
            name: t.activityName,
            transitionState: s,
            params: t.activityParams,
            context: t.activityContext,
            steps: [{
              id: t.activityId,
              params: t.activityParams,
              pushedBy: t
            }],
            pushedBy: t,
            metadata: {
              poppedBy: null
            },
            isTop: !1,
            isActive: !1,
            zIndex: -1
          };

          if (typeof _o == "number") f[_o] = l;else {
            var S = f.filter(function (x) {
              return x.metadata.poppedBy === null;
            }).sort(function (x, k) {
              return k.pushedBy.eventDate - x.pushedBy.eventDate;
            })[0];
            f.push(l), S && s === "enter-done" && (S.metadata.poppedBy = t, S.transitionState = "exit-done");
          }
          break;
        }

      case "Popped":
        {
          var _o2 = f.filter(function (s, l) {
            return l > 0;
          }).filter(function (s) {
            return s.metadata.poppedBy === null;
          }).sort(function (s, l) {
            return l.pushedBy.eventDate - s.pushedBy.eventDate;
          })[0],
              _c = t.skipExitActiveState || i - t.eventDate >= E ? "exit-done" : "exit-active";

          _o2 && (_o2.metadata.poppedBy = t, _o2.transitionState = _c, _c === "exit-done" && (_o2.params = _o2.steps[0].params, _o2.steps = [_o2.steps[0]]));
          break;
        }

      case "StepPushed":
        {
          var _o3 = f.filter(function (c) {
            return c.metadata.poppedBy === null;
          }).sort(function (c, s) {
            return s.pushedBy.eventDate - c.pushedBy.eventDate;
          })[0];

          if (_o3) {
            var _c2 = {
              id: t.stepId,
              params: t.stepParams,
              pushedBy: t
            };
            _o3.params = t.stepParams, _o3.steps = _o3.steps ? [].concat(_toConsumableArray(_o3.steps), [_c2]) : [_c2];
          }

          break;
        }

      case "StepReplaced":
        {
          var _o4 = f.filter(function (c) {
            return c.metadata.poppedBy === null;
          }).sort(function (c, s) {
            return s.pushedBy.eventDate - c.pushedBy.eventDate;
          })[0];

          if (_o4) {
            _o4.params = t.stepParams;
            var _c3 = {
              id: t.stepId,
              params: t.stepParams,
              pushedBy: t
            };
            _o4.steps.pop(), _o4.steps = [].concat(_toConsumableArray(_o4.steps), [_c3]);
          }

          break;
        }

      case "StepPopped":
        {
          var _o5 = f.filter(function (c) {
            return c.metadata.poppedBy === null;
          }).sort(function (c, s) {
            return s.pushedBy.eventDate - c.pushedBy.eventDate;
          })[0];

          if (_o5 && _o5.steps.length > 1) {
            _o5.steps.pop();

            var _c4 = (y = I(_o5.steps)) == null ? void 0 : y.params;

            _c4 && (_o5.params = _c4);
          }

          break;
        }

      default:
        break;
    }
  });

  var d = _(f, function (t) {
    return t.id;
  }),
      n = d.filter(function (t) {
    return t.transitionState === "enter-active" || t.transitionState === "enter-done" || t.transitionState === "exit-active";
  }),
      A = n.filter(function (t) {
    return t.transitionState === "enter-active" || t.transitionState === "enter-done";
  }),
      u = n[n.length - 1],
      r = A[A.length - 1],
      m = f.find(function (t) {
    return t.transitionState === "enter-active" || t.transitionState === "exit-active";
  }) ? "loading" : "idle";

  return {
    activities: d.map(function (t) {
      return v({
        id: t.id,
        name: t.name,
        transitionState: t.transitionState,
        params: t.params,
        steps: t.steps,
        pushedBy: t.pushedBy,
        isTop: (u == null ? void 0 : u.id) === t.id,
        isActive: (r == null ? void 0 : r.id) === t.id,
        zIndex: n.findIndex(function (_ref) {
          var y = _ref.id;
          return y === t.id;
        })
      }, t.context ? {
        context: t.context
      } : null);
    }).sort(function (t, y) {
      return R(t, y, function (o) {
        return o.id;
      });
    }),
    registeredActivities: h.map(function (t) {
      return v({
        name: t.activityName
      }, t.activityParamsSchema ? {
        paramsSchema: t.activityParamsSchema
      } : null);
    }),
    transitionDuration: E,
    globalTransitionState: m
  };
}

import J from "react-fast-compare";
import U from "react-fast-compare";

function O(a, i) {
  var h, E;
  var e = [];
  !U(a, i) && e.push({
    _TAG: "%SOMETHING_CHANGED%"
  });

  for (var f = 0; f < Math.max(a.activities.length, i.activities.length); f += 1) {
    var d = a.activities[f],
        n = i.activities[f],
        A = (d == null ? void 0 : d.transitionState) === "exit-done" || (d == null ? void 0 : d.transitionState) === "exit-active",
        u = (n == null ? void 0 : n.transitionState) === "enter-active" || (n == null ? void 0 : n.transitionState) === "enter-done";
    if (d && n && d.id === n.id) for (var r = 0; r < Math.max(((h = d.steps) != null ? h : []).length, ((E = n.steps) != null ? E : []).length); r += 1) {
      var m = d.steps[r],
          p = n.steps[r];
      !m && p ? e.push({
        _TAG: "STEP_PUSHED",
        activity: n,
        step: p
      }) : m && !p ? e.push({
        _TAG: "STEP_POPPED",
        activity: n
      }) : d.steps.length === n.steps.length && m.id !== p.id && e.push({
        _TAG: "STEP_REPLACED",
        activity: n,
        step: p
      });
    }
    !d && n ? e.push({
      _TAG: n.pushedBy.name === "Pushed" ? "PUSHED" : "REPLACED",
      activity: n
    }) : A && u ? e.push({
      _TAG: n.pushedBy.name === "Pushed" ? "PUSHED" : "REPLACED",
      activity: n
    }) : d && n && d.id === n.id && !U(C(d, ["isActive", "isTop", "transitionState", "zIndex"]), C(n, ["isActive", "isTop", "transitionState", "zIndex"])) && n.pushedBy.name === "Replaced" && e.push({
      _TAG: "REPLACED",
      activity: n
    });
  }

  for (var _f = Math.max(a.activities.length, i.activities.length) - 1; _f >= 0; _f -= 1) {
    var _d = a.activities[_f],
        _n = i.activities[_f],
        _A = (_d == null ? void 0 : _d.transitionState) === "enter-done" || (_d == null ? void 0 : _d.transitionState) === "enter-active",
        _u = (_n == null ? void 0 : _n.transitionState) === "exit-active" || (_n == null ? void 0 : _n.transitionState) === "exit-done";

    _A && _u && e.push({
      _TAG: "POPPED",
      activity: _n
    });
  }

  return e;
}

var Q = 1e3,
    W = Q / 60;

function Ot(a) {
  var i = {
    value: _toConsumableArray(a.initialEvents)
  },
      e = {
    value: B(i.value, new Date().getTime())
  },
      P = [],
      E = [function () {
    return {
      key: "@stackflow/core",
      onChanged: function onChanged() {
        P.forEach(function (r) {
          return r();
        });
      }
    };
  }()].concat(_toConsumableArray(a.plugins.map(function (r) {
    return r();
  }))),
      f = function f(r) {
    var m = O(e.value, r);
    e.value = r, A(m, E);
  },
      d = function d(r, m) {
    var p = D(r, m),
        t = B([].concat(_toConsumableArray(i.value), [p]), new Date().getTime());
    i.value.push(p), f(t);
    var y = setInterval(function () {
      var o = B(i.value, new Date().getTime());
      J(e.value, o) || f(o), o.globalTransitionState === "idle" && clearInterval(y);
    }, W);
  };

  function n(r, m) {
    var p = !1,
        t = v({}, r);

    function y(s) {
      var l = v({}, s);
      return delete l.name, l;
    }

    var o = function o() {
      p = !0;
    },
        c = function c(s) {
      t = v(v({}, t), s);
    };

    return m.forEach(function (s) {
      var l, S, x, k, N, G;

      switch (t.name) {
        case "Pushed":
          {
            (l = s.onBeforePush) == null || l.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        case "Replaced":
          {
            (S = s.onBeforeReplace) == null || S.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        case "Popped":
          {
            (x = s.onBeforePop) == null || x.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        case "StepPushed":
          {
            (k = s.onBeforeStepPush) == null || k.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        case "StepReplaced":
          {
            (N = s.onBeforeStepReplace) == null || N.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        case "StepPopped":
          {
            (G = s.onBeforeStepPop) == null || G.call(s, {
              actionParams: v({}, t),
              actions: T(v({}, u), {
                preventDefault: o,
                overrideActionParams: c
              })
            });
            break;
          }

        default:
          break;
      }
    }), {
      isPrevented: p,
      overriddenParams: y(t)
    };
  }

  function A(r, m) {
    r.forEach(function (p) {
      m.forEach(function (t) {
        var y, o, c, s, l, S, x;

        switch (p._TAG) {
          case "PUSHED":
            return (y = t.onPushed) == null ? void 0 : y.call(t, {
              actions: u,
              effect: p
            });

          case "REPLACED":
            return (o = t.onReplaced) == null ? void 0 : o.call(t, {
              actions: u,
              effect: p
            });

          case "POPPED":
            return (c = t.onPopped) == null ? void 0 : c.call(t, {
              actions: u,
              effect: p
            });

          case "STEP_PUSHED":
            return (s = t.onStepPushed) == null ? void 0 : s.call(t, {
              actions: u,
              effect: p
            });

          case "STEP_REPLACED":
            return (l = t.onStepReplaced) == null ? void 0 : l.call(t, {
              actions: u,
              effect: p
            });

          case "STEP_POPPED":
            return (S = t.onStepPopped) == null ? void 0 : S.call(t, {
              actions: u,
              effect: p
            });

          case "%SOMETHING_CHANGED%":
            return (x = t.onChanged) == null ? void 0 : x.call(t, {
              actions: u,
              effect: p
            });

          default:
            return;
        }
      });
    });
  }

  var u = {
    getStack: function getStack() {
      return e.value;
    },
    dispatchEvent: d,
    push: function push(r) {
      var _n2 = n(D("Pushed", r), E),
          m = _n2.isPrevented,
          p = _n2.overriddenParams;

      m || d("Pushed", p);
    },
    replace: function replace(r) {
      var _n3 = n(D("Replaced", r), E),
          m = _n3.isPrevented,
          p = _n3.overriddenParams;

      m || d("Replaced", p);
    },
    pop: function pop(r) {
      var _n4 = n(D("Popped", r != null ? r : {}), E),
          m = _n4.isPrevented,
          p = _n4.overriddenParams;

      m || d("Popped", p);
    },
    stepPush: function stepPush(r) {
      var _n5 = n(D("StepPushed", r != null ? r : {}), E),
          m = _n5.isPrevented,
          p = _n5.overriddenParams;

      m || d("StepPushed", p);
    },
    stepReplace: function stepReplace(r) {
      var _n6 = n(D("StepReplaced", r != null ? r : {}), E),
          m = _n6.isPrevented,
          p = _n6.overriddenParams;

      m || d("StepReplaced", p);
    },
    stepPop: function stepPop(r) {
      var _n7 = n(D("StepPopped", r != null ? r : {}), E),
          m = _n7.isPrevented,
          p = _n7.overriddenParams;

      m || d("StepPopped", p);
    }
  };
  return {
    actions: u,
    init: L(function () {
      E.forEach(function (r) {
        var m;
        (m = r.onInit) == null || m.call(r, {
          actions: u
        });
      });
    }),
    subscribe: function subscribe(r) {
      return P.push(r), function () {
        var p = P.findIndex(function (t) {
          return t === r;
        });
        p > -1 && P.splice(p, 1);
      };
    }
  };
}

export { B as aggregate, Ot as createCoreStore, w as id, D as makeEvent, O as produceEffects };